module.exports = __webpack_public_path__ + "img/collection-weddingRingsBestseller.c50636c.jpg";